import {PositionPointCriteria} from "./PositionPointCriteria"

export class StiffenersSettings{
    PositionGaugingPointsOnStiffeners: boolean;
    PositionGaugingPointsOnBays: boolean;
    InsertPointsOnWeb: boolean;
    InsertPointsOnFlange: boolean;
    PositionPointCriteriaList: PositionPointCriteria[];
    PositionGaugingsforCriticalAreas: boolean
    CriticalAreaThreshold: number;
    PositionGaugingPointsOnFrames: boolean;    
    FrameSpacing: number;

}